import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/badges/app-store.svg")